
import React from "react";
import { useState } from 'react';
import pageData from "../PageData";
const changePassword =()=>{ 

//const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
//const [userName, setUserName] = useState("Naveen"); 
return (
 <>
		    Change Password
		</>

);
}
export default changePassword;